<template>
    <div
        class="main-menu"
        id="main-sidebar">
        <div class="tabs">
            <ul>
                <li>
                    <div class="tab">
                        <div
                            class="tab-label"
                            :class="{
                                active: selectedProject === 'all',
                            }"
                            @click="selectProject('all')">
                            All Projects
                        </div>
                    </div>
                </li>
                <li
                    v-for="project in projects"
                    :key="project.id">
                    <div
                        class="tab"
                        @click="selectProject(project)">
                        <div
                            class="tab-label"
                            :class="{
                                active: selectedProject?.id === project.id,
                            }">
                            {{ project.name }}
                            <!-- <img :src="project.image" alt="project-image" /> -->
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { getProjects } from '@/services/axios/projects.service';

export default {
    name: 'MainMenu',
    props: {},

    data() {
        return {
            selectedProject: 'all',
        };
    },

    mounted() {
        this._getProjects();
    },

    computed: {
        projects() {
            const allProjects = this.$store.state.projects;
            const selectedOwnerName = this.$store.state.selectedOwnerName;

            if (!selectedOwnerName) {
                return allProjects;
            }

            return allProjects.filter(
                project => project.company.owner_name === selectedOwnerName
            );
        },
    },

    methods: {
        async _getProjects() {
            try {
                const _projects = await getProjects();
                const projects = _projects.data.result;

                // Extract unique companies by owner_name
                const companies = [];
                const ownerNames = new Set();

                projects.forEach(project => {
                    if (
                        project.company.owner_name &&
                        !ownerNames.has(project.company.owner_name)
                    ) {
                        companies.push({
                            id: project.company.id,
                            name: project.company.name,
                            owner_name: project.company.owner_name,
                            logo: project.company.logo,
                            thumbnail_logo: project.company.thumbnail_logo,
                            primary_color: project.company.primary_color,
                        });
                        ownerNames.add(project.company.owner_name);
                    }
                });

                this.$store.commit('mutationer', {
                    projects: projects,
                    companies: companies,
                });

                // Set default selection to 'All Projects'
                this.selectProject('all');
            } catch (error) {
                console.log(error);
            }
        },
        selectProject(project) {
            if (project === 'all') {
                this.selectedProject = 'all';
                const allServices = [];
                this.projects.forEach(proj => {
                    if (proj.services && proj.services.length > 0) {
                        allServices.push(...proj.services);
                    }
                });
                this.$store.commit('mutationer', { services: allServices });
            } else {
                this.selectedProject = project;
                const projectServices = project.services || [];
                this.$store.commit('mutationer', { services: projectServices });
            }
        },
    },

    watch: {
        projects: {
            handler(newProjects) {
                if (this.selectedProject === 'all') {
                    this.selectProject('all');
                } else if (
                    newProjects.length &&
                    this.selectedProject !== 'all' &&
                    (!this.selectedProject ||
                        !newProjects.find(
                            p => p.id === this.selectedProject?.id
                        ))
                ) {
                    this.selectProject('all');
                }
            },
            immediate: true,
        },
    },
};
</script>
